import React from "react";

import { DummyToc } from "src/views/sign-up/DummyToc";
import { HtxToc } from "src/views/sign-up/HtxToc";
import { KdToc } from "src/views/sign-up/KdToc";
import { KtxToc } from "src/views/sign-up/KtxToc";

export function getToc(mod: string | undefined): React.FunctionComponent {
	if (mod === "htx") {
		return HtxToc;
	}
	if (mod === "ktx") {
		return KtxToc;
	}
	if (mod === "kd") {
		return KdToc;
	}
	return DummyToc;
}
